// TabLayout.tsx
import * as React from 'react'
import { useTabStore } from "../providers/TabProvider";
import { tabRoutes } from "../tabs"; // Assuming this is where your tabRoutes is defined
import { Stack } from './Stack';

export default function TabLayout() {
    const activeTab = useTabStore((s) => s.activeTab);
    const tab = tabRoutes.find((t) => t.key === activeTab);

    if (!tab || typeof tab.component !== "function") {
        return (
            <Stack horizontalAlign="center" verticalAlign="center" gap="small">
                Tab not found or invalid component
            </Stack>
        );
    }

    return React.createElement(tab.component);
}